import {
    WebDataSteps,
    serializedErrorToWebDataError,
    webDataLoading,
    webDataNotAsked,
    webDataSuccess,
} from "@lvt/web-data";
import { createSlice } from "@reduxjs/toolkit";

import { liveUnitMosaicApi } from "@/api/liveUnitMosaic/liveUnitMosaic";
import { fetchStreamMetadata } from "@/api/streamMetadata";

import { StreamDataState } from "./types";


const initialState: StreamDataState & { requestId: string } = {
    streamMeta: webDataNotAsked(),
    requestId: "",
};

export const streamDataSlice = createSlice({
    name: "stream",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchStreamMetadata.pending, (state, action) => {
                state.streamMeta = webDataLoading();
                state.requestId = action.meta.requestId;
            })
            .addCase(fetchStreamMetadata.fulfilled, (state, action) => {
                if (state.requestId === action.meta.requestId) {
                    console.log("streamData/slice camera id: ", action.payload.cameraId);
                    state.streamMeta = webDataSuccess(action.payload);
                }
            })
            .addCase(fetchStreamMetadata.rejected, (state, action) => {
                state.streamMeta = serializedErrorToWebDataError(action.error);
            })
            .addMatcher(liveUnitMosaicApi.endpoints.addPreset.matchFulfilled, (state, action) => {
                if (state.streamMeta.type == WebDataSteps.Success) {
                    const streamMeta = state.streamMeta.payload;
                    const { name, cameraId } = action.meta.arg.originalArgs;

                    if (cameraId === streamMeta.cameraId) {
                        const id = action.payload;

                        streamMeta.presets.push({ id, name, isHome: false });
                    }
                }
            })
            .addMatcher(liveUnitMosaicApi.endpoints.updatePreset.matchFulfilled, (state, action) => {
                if (state.streamMeta.type == WebDataSteps.Success) {
                    const streamMeta = state.streamMeta.payload;
                    const { name, presetId } = action.meta.arg.originalArgs;

                    const preset = streamMeta.presets.find(p => p.id === presetId);

                    if (preset) {
                        preset.name = name;
                    }
                }
            })
            ;
    },
});

export const streamDataReducer = streamDataSlice.reducer;
